import styled from 'styled-components'

// SureCo Figma design tokens
const TEAL = '#00A5AD'
const TEAL_BG = '#F0FBFB'
const TEXT_DARK = '#1A2B3C'
const TEXT_MUTED = '#9CA3AF'
const BORDER = '#E5E7EB'
const RADIUS = '0.5rem'
const FONT = "'Inter', ui-sans-serif, system-ui, sans-serif"

export const FeesWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 6px 2px 16px;
  overflow-y: auto;
  font-family: ${FONT};
`

export const StructureTagWrap = styled.span`
  & .ant-tag {
    margin-inline-end: 0;
  }
`

export const SectionTitle = styled.div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: ${TEXT_MUTED};
`

// Single-line headcount strip: small label/value pairs separated by dividers.
export const HeadStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
  padding: 8px 12px;
  border: 1px solid ${BORDER};
  border-radius: ${RADIUS};
`

export const HeadItem = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  font-size: 12px;
  color: ${TEXT_MUTED};

  b {
    font-size: 13px;
    font-weight: 700;
    color: ${TEXT_DARK};
    font-variant-numeric: tabular-nums;
  }

  &[data-accent='true'] b {
    color: ${TEAL};
  }
`

// Compact rates/fees table: Item | PEPM | Fee.
export const FeeTable = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  border: 1px solid ${BORDER};
  border-radius: ${RADIUS};
  overflow: hidden;
`

// `display: contents` keeps each row's cells as direct grid items of FeeTable
// (so the grid layout is unchanged) while giving the markup real table rows for
// screen readers.
export const FeeRow = styled.div`
  display: contents;
`

export const FeeHeadCell = styled.div`
  padding: 6px 12px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${TEXT_MUTED};
  background: #fafafa;
  border-bottom: 1px solid ${BORDER};
  text-align: right;

  &:first-child {
    text-align: left;
  }
`

export const FeeCell = styled.div<{ $accent?: boolean; $strong?: boolean }>`
  padding: 7px 12px;
  font-size: 13px;
  color: ${TEXT_DARK};
  text-align: right;
  font-variant-numeric: tabular-nums;
  border-bottom: 1px solid ${BORDER};
  background: ${({ $accent }) => ($accent ? TEAL_BG : 'transparent')};
  font-weight: ${({ $strong }) => ($strong ? 700 : 400)};

  &:first-child {
    text-align: left;
    font-weight: 600;
    color: ${TEXT_DARK};
  }

  /* last row: drop the trailing border */
  ${FeeRow}:last-child & {
    border-bottom: none;
  }
`

// Right-aligned monthly value with the PEPM × billable derivation beneath it.
export const MonthlyCalc = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.25;

  small {
    font-size: 10px;
    font-weight: 400;
    color: ${TEXT_MUTED};
    font-variant-numeric: tabular-nums;
  }
`

// Slim total bar.
export const TotalCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: ${TEAL};
  border-radius: ${RADIUS};
  color: #fff;
`

export const TotalLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.92;
`

export const TotalValue = styled.span`
  font-size: 20px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
`

export const TotalHint = styled.span`
  font-size: 11px;
  color: ${TEXT_MUTED};
  padding: 0 2px;
`
